import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LocationSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LocationSVG;
